export const LightTheme = {
    bodybgColor: '#ffffff',
    textColor: '#000000',
    divbgColor: 'lightgreen',
};
